import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAI: CultureInfo = {
  name: 'en-AI',
  displayName: 'English (Anguilla)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AI',
  parent: CultureInfoEn
};
